import { authClient } from "~/libs/auth.lib";
import { clearAllLocalData } from "~/libs/local-data";

export const logout = async (): Promise<void> => {
  try {
    await authClient.signOut();
  } finally {
    await clearAllLocalData();
    window.location.replace("/login");
  }
};

export const googleLogin = async (redirectPath?: string) => {
  // Route the OAuth round-trip through `/auth/callback` (an ungated route)
  // so we don't bounce through `_app/route` -> `/login` while
  // `authClient.getSession()` is still resolving. `/auth/callback`
  // renders a spinner and forwards to `redirect` once `user$.id` is set.
  const params = redirectPath
    ? `?redirect=${encodeURIComponent(redirectPath)}`
    : "";
  await authClient.signIn.social({
    provider: "google",
    callbackURL: `${import.meta.env.VITE_DOMAIN}/auth/callback${params}`,
    errorCallbackURL: `${import.meta.env.VITE_DOMAIN}/login`,
  });
};

export const signInWithEmail = async (email: string, password: string) => {
  // When the sign-in happens mid-OAuth-flow, `oauthProviderClient` forwards the
  // signed `oauth_query` and the server resumes authorization, returning a
  // `{ redirect: true, url }` continuation in `data`. The caller follows it.
  const { data, error } = await authClient.signIn.email({
    email,
    password,
  });
  return { data, error };
};
